import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { OnScreenMessageService } from '../services/onScreenMessage/onScreenMessage.sevice';
@Component({
  selector: 'app-scv-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginform: FormGroup;
  authStr: string;
  language: boolean = false;

  Languages: any[];
  selectedLang: string;
  arr: Array<string> = [];
  checked1 = true;
  particlesJS: any;
  ee: number = 0;
  credits: string = "none";

  @Output() LangeSwitch: EventEmitter<any> = new EventEmitter()
  constructor(private translate: TranslateService, private onScreenMessageService: OnScreenMessageService, private router: Router, private authService: AuthService) {
  }

  ngOnInit() {
    this.translate.setDefaultLang('fr');
    localStorage.setItem('defaultLang','fr')
    this.loginform = new FormGroup({
      'userName': new FormControl('', Validators.required),
      'password': new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),
      'language': new FormControl('fr', Validators.required),
    });

      this.Languages = [
        {label: 'English', value: 'en'},
        {label: 'French', value:'fr'},
      ];
  }

  onSubmit(username, password) {
    this.authorise(username, password);
  }


  ngAfterViewInit(){
    this.translate.use('fr');
    (localStorage.getItem('defaultLang') === 'fr') ? this.checked1 = true : this.checked1 = false
  }


  handleEvent(e) {
      this.translate.use(e.value);
      localStorage.setItem('defaultLang', e.value)
  }

  Success() {
  }

  authorise(userName, password) {
      this.authService.login(userName, password).subscribe((userdata) => {
           if (userdata.group) {
            this.authService.setLdapGroups(userdata.group); 
            localStorage.setItem('group',JSON.stringify(userdata.group));
            localStorage.setItem('token',userdata.token);
            localStorage.setItem('role',userdata.role);
            let lang = localStorage.getItem('defaultLang')
            this.router.navigate(['/Home']);
            localStorage.setItem('isAutenticatedUser', 'true');
            localStorage.setItem('defaultLang', lang);
            this.authService.isLoggedIn = true
            // todo: direct set role in localstorage instead of usedata object.
            const UserData = { 'userRole': `SCV.LABEL.${userdata.role}`, 'lastName': userdata.userName}
            localStorage.setItem('user', JSON.stringify(UserData))
           }
        },(error) => {
          if (error.error.status === 'Unauthorized') {
             this.onScreenMessageService.Error(this.translate.instant('SCV.LOG.MSGKOUSERPWD'));
          }
           else  this.onScreenMessageService.Error(error.error.message)
      })
  
  }

  pass(data:number){
    this.ee = this.ee * 10 + data;
  }
  
  image(){
    if(this.ee == 1322){
      this.credits = "block";
      setTimeout(() => {
        this.credits = "none";
      }, 5000);
    }
    this.ee = 0;
  }
}
